<template>
  <jet-authentication-card>
    <card-header>
      {{ isInvitation ? 'Set Your Password' : 'Participant - Reset Password' }}
    </card-header>
    <template #logo>
      <jet-authentication-card-logo />
    </template>

    <jet-validation-errors class="mt-4 px-6" />

    <form @submit.prevent="submit" class="p-6">
      <div>
        <jet-label for="email" value="Email" />
        <jet-input
          id="email"
          type="email"
          class="mt-1 block w-full"
          v-model="form.email"
          required
          autofocus
          autocomplete="on"
        />
      </div>

      <div class="mt-4">
        <jet-label for="password" value="Password" />
        <jet-input
          id="password"
          type="password"
          class="mt-1 block w-full"
          v-model="form.password"
          required
          autocomplete="new-password"
          @input="checkPassword"
        />
      </div>

      <div v-if="passwordValidationFailed" class="mt-1 block text-xxs text-gray-500">
        <span>Password doesn't match the requirements</span>
      </div>

      <div class="mt-4">
        <jet-label for="password_confirmation" value="Confirm password" />
        <jet-input
          id="password_confirmation"
          type="password"
          class="mt-1 block w-full"
          v-model="form.password_confirmation"
          required
          autocomplete="new-password"
        />
      </div>
      <PasswordChecklist
        class="mt-4"
        :password="form.password"
        @validated="validated"
      ></PasswordChecklist>
      <div class="flex items-center justify-end mt-4">
        <jet-button
          :class="{ 'opacity-25': form.processing || passwordValidationFailed }"
          :disabled="form.processing || passwordValidationFailed"
        >
          {{ isInvitation ? 'Set Password' : 'Reset Password' }}
        </jet-button>
      </div>
    </form>
  </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import CardHeader from '@/Components/Cards/CardHeader.vue';
import PasswordChecklist from '@/Components/PasswordChecklist.vue';

export default {
  components: {
    PasswordChecklist,
    CardHeader,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetLabel,
    JetValidationErrors,
  },

  props: {
    email: String,
    token: String,
    updateRouteName: {
      type: String,
      default: 'password.update',
    },
    isInvitation: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: this.$inertia.form({
        token: this.token,
        email: this.email,
        password: '',
        password_confirmation: '',
      }),
      passwordValidationFailed: false,
    };
  },

  methods: {
    submit() {
      this.form.post(this.route(this.updateRouteName), {
        onFinish: () => this.form.reset('password', 'password_confirmation'),
      });
    },
    checkPassword() {
      this.$emit('input', this.password);
    },
    validated(e) {
      this.passwordValidationFailed = e;
    },
  },
};
</script>
